import { render, staticRenderFns } from "./PrimitiveBaseModal.vue?vue&type=template&id=1692851a&scoped=true&"
import script from "./PrimitiveBaseModal.vue?vue&type=script&lang=js&"
export * from "./PrimitiveBaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1692851a",
  null
  
)

export default component.exports